import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import api from "../lib/api";

const AdminAI = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/admin/ai-settings").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="text-sm">Loading…</div>;

  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/admin/ai-settings", s); setS(r.data); toast.success("AI settings saved"); }
    catch { toast.error("Save failed"); }
    finally { setBusy(false); }
  };

  const set = (k) => (v) => setS({ ...s, [k]: v });

  return (
    <div className="space-y-6" data-testid="admin-ai">
      <div className="flex items-end justify-between gap-4">
        <div>
          <div className="overline text-[#7A1519]">AI Assistant</div>
          <h1 className="font-display text-3xl md:text-4xl tracking-tight font-semibold">Assistant Configuration</h1>
        </div>
        <button onClick={save} disabled={busy} className="bg-[#7A1519] text-white px-6 py-3 rounded-sm text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-60" data-testid="ai-save">
          <Save size={14} /> Save
        </button>
      </div>

      <div className="bg-white border hairline p-6 rounded-sm space-y-5">
        <label className="flex items-center justify-between gap-4 pb-4 border-b hairline">
          <div>
            <div className="font-medium">Enable AI Assistant</div>
            <div className="text-xs text-[#242424]/60">When off, the chat widget is hidden across the site.</div>
          </div>
          <input type="checkbox" checked={!!s.enabled} onChange={(e) => set("enabled")(e.target.checked)} className="h-5 w-5 accent-[#7A1519]" data-testid="ai-toggle" />
        </label>

        <Field label="Welcome Message" multiline value={s.welcome_message} onChange={set("welcome_message")} testId="ai-welcome" />
        <Field label="Escalation Message" multiline value={s.escalation_message} onChange={set("escalation_message")} testId="ai-esc" />
        <Field label="Dealership Info (used as context for the assistant)" multiline value={s.dealership_info} onChange={set("dealership_info")} testId="ai-info" />
        <Field label="FAQs (freeform)" multiline value={s.faqs} onChange={set("faqs")} testId="ai-faqs" />
      </div>

      <div className="bg-white border hairline p-6 rounded-sm">
        <div className="overline text-[#7A1519] mb-3">How this works</div>
        <ul className="text-sm text-[#242424]/80 space-y-2 list-disc pl-5">
          <li>The assistant reads live inventory (all available/reserved/coming-soon vehicles) at every request.</li>
          <li>Prices, kilometres and features come directly from the inventory database — no separate maintenance.</li>
          <li>WhatsApp escalation number is taken from Settings → Contact information.</li>
        </ul>
      </div>
    </div>
  );
};

const Field = ({ label, value, onChange, multiline = false, testId }) => (
  <div>
    <label className="overline text-[#242424]/60 block mb-2">{label}</label>
    {multiline ? (
      <textarea rows={4} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="w-full bg-[#F7F6F3] border hairline rounded-sm px-4 py-2.5 text-sm" data-testid={testId} />
    ) : (
      <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="w-full bg-[#F7F6F3] border hairline rounded-sm px-4 py-2.5 text-sm" data-testid={testId} />
    )}
  </div>
);

export default AdminAI;
